<template>
  <div>
    <vx-card class="shadow-sm" :title="$t('ComplaintDetails')" v-if="complaintData.Id || complaintData.id">
      
      <!-- البيانات الأساسية -->
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('ComplaintCode') }}</label>
          <vs-input disabled v-model="complaintData.ComplaintCode" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('UserName') }}</label>
          <vs-input disabled v-model="complaintData.UserName" class="w-full" />
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <label>{{ $t('Status') }}</label>
          <div class="mt-2">
            <vs-chip :color="getStatusColor(complaintData.Status)">
              {{ getStatusText(complaintData.Status) }}
            </vs-chip>
          </div>
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col md:w-3/4 w-full">
          <label>{{ $t('Title') }}</label>
          <vs-input disabled v-model="complaintData.Title" class="w-full font-bold" />
        </div>
        <div class="vx-col md:w-1/4 w-full">
          <label>{{ $t('Type') }}</label>
          <vs-input disabled :value="complaintData.Type === 1 ? $t('Complaint') : $t('Suggestion')" class="w-full" />
        </div>
      </div>

      <div class="vx-row mt-4">
        <div class="vx-col w-full">
          <label>{{ $t('Content') }}</label>
          <vs-textarea disabled v-model="complaintData.Content" class="w-full" rows="5" />
        </div>
      </div>

    
      <div class="vx-row mt-4" v-if="complaintData.AttachmentUrl">
        <div class="vx-col w-full">
          <label>{{ $t('Attachment') }}</label>
          <div class="p-4 border border-dashed rounded flex items-center justify-between bg-grey-light">
            <span>{{ $t('File Attached') }}</span>
            <vs-button 
              type="flat" 
              icon-pack="feather" 
              icon="icon-download" 
              :href="baseURL + complaintData.AttachmentUrl" 
              target="_blank"
            >
              {{ $t('View / Download') }}
            </vs-button>
          </div>
        </div>
      </div>

     
      <div class="vx-row mt-6 pt-6 border-t border-grey-light">
        <div class="vx-col w-full">
          <label class="text-primary font-bold">{{ $t('AdminReply') }}</label>
          <vs-textarea 
            :disabled="complaintData.Status === 2" 
            v-model="complaintData.AdminReply" 
            :placeholder="$t('WriteReplyPlaceholder')" 
            class="w-full" 
            rows="5" 
          />
        </div>
      </div>
      <!-- ======================================================== -->

    </vx-card>

    <div v-else class="text-center p-10">
       <vs-progress indeterminate color="primary"></vs-progress>
    </div>


    <div class="vx-row mb-4 ml-10">
      <div class="mt-8 flex flex-wrap items-center justify-end w-full">
        <vs-button type="border" icon-pack="feather" icon="icon-arrow-left" @click="cancel" class="px-4 w-full md:w-auto mr-4">
          {{ $t("Back") }}
        </vs-button>

   
        <vs-button 
          v-if="complaintData.Status !== 2"
          color="success"
          icon-pack="feather"
          icon="icon-send"
          @click="submitAdminReply"
          class="px-4 w-full md:w-auto"
        >
          {{ $t("SubmitReplyAndResolve") }}
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import moduleComplaintSuggestion from "@/store/ComplaintSuggestions/moduleComplaintSuggestion.js";
import { domain } from "@/gloabelConstant.js";

export default {
  components: { VxCard },
  data() {
    return {
      baseURL: domain,
      complaintData: {
        AdminReply: "" 
      }
    };
  },
  methods: {
    getStatusColor(status) {
      if (status === 1) return "warning";
      if (status === 2) return "success"; 
      return "grey";
    },
    getStatusText(status) {
      if (status === 1) return this.$t("Pending");
      if (status === 2) return this.$t("Completed");
      return this.$t("New");
    },
    
    submitAdminReply() {
      if (!this.complaintData.AdminReply || !this.complaintData.AdminReply.trim()) {
        this.$vs.notify({
          title: this.$t('Warning'),
          text: this.$t('ReplyRequiredMessage'),
          color: 'warning',
          icon: 'icon-alert-circle',
          iconPack: 'feather'
        });
        return;
      }

      this.$vs.loading();


      const payload = { 
        ...this.complaintData, 
        Status: 2,
        AdminReply: this.complaintData.AdminReply 
      };

      this.$store
        .dispatch("ComplaintSuggestionsList/markAsResolved", payload)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({ title: this.$t('Success'), color: 'success', icon: 'icon-check', iconPack: 'feather' });
          this.cancel();
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({ title: 'Error', text: err.message, color: 'danger' });
        });
    },
    cancel() {
      this.$router.go(-1);
    }
  },
  created() {
    if (!moduleComplaintSuggestion.isRegistered) {
      this.$store.registerModule("ComplaintSuggestionsList", moduleComplaintSuggestion);
      moduleComplaintSuggestion.isRegistered = true;
    }

    const ID = this.$route.params.ID;

    if (ID) {
      this.$vs.loading();
      this.$store
        .dispatch("ComplaintSuggestionsList/GetItemByID", ID)
        .then((res) => {
          this.$vs.loading.close();
          const data = res.data.data || res.data.Data;
       
          if(data) {
            data.AdminReply = data.AdminReply || data.adminReply || "";
          }
          this.complaintData = data; 
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: this.$t("Error"),
            text: (err.response && err.response.data && err.response.data.message) ? err.response.data.message : "Error fetching data",
            color: "danger",
          });
        });
    }
  }
};
</script>

<style lang="scss">
#MainData {
  .vs-textarea {
    background: #f9f9f9 !important;
    color: #333 !important;
    cursor: default !important;
  }
  label {
    font-weight: 600;
    color: #1f2b38;
    margin-bottom: 8px;
    display: block;
  }
}
</style>